module.exports = __webpack_public_path__ + "ebd4f06f95b6fbfc9d05162c4071d1a7.jpg";